import React, { useState } from 'react';
import './Agriculture.css';
import Agri from '../assets/agri.png';
import PdfViewer2 from '../About/PdfViewer3';
import Loader from '../Loader/Loader'; // import the Loader component


const Agriculture = () => {
  const [showPdfViewer1, setShowPdfViewer1] = useState(false);
  const [loading, setLoading] = useState(false); // add state for loading indicator

  function handleReadMoreClick() {
    setLoading(true); // set loading state to true
    setTimeout(() => {
      setShowPdfViewer1(true);
      setLoading(false); // set loading state to false when the PDF viewer is ready
    }, 5000);
  }

  return (
    <div className="image-description">
      <div className="description">
        <h2>Agriculture, Forestry and Fishing output as a % of GCP</h2>
        {loading ? (
          <Loader /> // show the loading indicator
        ) : showPdfViewer1 ? (
          <PdfViewer2 onClose={() => setShowPdfViewer1(false)} />
        ) : (
          <>
            <p>Agriculture, forestry, and fishing contribute significantly to the country's economy and provide employment opportunities for millions of  ...</p>
            <button className="read-more-button" onClick={handleReadMoreClick}>Read More</button>
          </>
        )}
      </div>
      <img src={Agri} alt='asals' className="image" />
    </div>
  );
};

export default Agriculture;
